import { render, staticRenderFns } from "./approvals_auth.vue?vue&type=template&id=18e13a72"
import script from "./approvals_auth.vue?vue&type=script&lang=js"
export * from "./approvals_auth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports